export default {
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
